<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/article/add')"
      >添加</el-button
    >
    <el-button
      type="danger"
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1),  fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >

    <el-input
      style="float: right; width: 200px"
      v-model="screen.title"
      placeholder="请输入标题"
    ></el-input>
    <el-select
      style="float: right"
      v-model="screen.type"
      placeholder="请选择类型"
    >
      <el-option
        label="全部类型"
        value=""
      ></el-option>
      <el-option
        label="新闻资讯"
        value="1"
      ></el-option>
      <el-option
        label="政策扶持"
        value="2"
      ></el-option>
    </el-select>
    <!-- <el-select
      filterable
      multiple
      collapse-tags
      style="float: right"
      v-model="screen.park_ids"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <!-- <el-table-column label="园区">
        <template slot-scope="scope">
          <span>{{ scope.row.park_all }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="封面图">
        <template slot-scope="scope">
          <!-- <img
            v-if="scope.row.thumb"
            class="tableIcon"
            alt=""
            srcset=""
            :src="imageUrl + scope.row.thumb"
          /> -->
          <el-image
            v-for="(img, ind) in scope.row.thumb.split(',')"
            :key="ind"
            style="width: 100px; height: 100px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.thumb.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="标题">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? '新闻资讯' : '政策扶持' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="浏览量">
        <template slot-scope="scope">
          {{ scope.row.visit_num }}
        </template>
      </el-table-column>
      <el-table-column label="发布时间">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/article/edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/article/del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="选择园区" prop="park_ids">
          <el-select
            filterable
            multiple
            collapse-tags
            v-model="ruleForm.park_ids"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="新闻标题" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入新闻标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="缩略图" prop="thumb">
          <el-upload
          :limit="1"
            :action="ossUpload"
            name="file[]"
            :data="{ type: 'image' }"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="cztype == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="ruleForm.thumb ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
         <el-form-item label="类型" prop="type">
          <el-radio-group
            v-model="ruleForm.type"
            :disabled="cztype == 'see'"
          >
            <el-radio
              :label="1"
              >新闻资讯</el-radio
            >
            <el-radio
              :label="2"
              >政策扶持</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            class="w4 numInput"
            v-model="ruleForm.sort"
            placeholder="请输入排序"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="新闻详情" prop="content">
          <Editor
            ref="myQuillEditor"
            style="width: 100%"
            v-model="ruleForm.content"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import {
  articleLists,
  addArticle,
  articleDetail,
  editArticle,
  delArticle,
  openPark,
  delImage,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_ids: [],
        title: "",
        type:''
      },
      total: 0,
      ruleForm: {
        park_ids: "",
        title: "",
        thumb: "",
        status: 1,
        content: "<h3>文本编辑</h3>",
        sort: "",
      },
      rules: {
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        // park_ids: [
        //   { required: true, message: "请选择所展示的园区", trigger: "change" },
        // ],
        thumb: [{ required: true, message: "请选择缩略图" }],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      fileList: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_ids.push(this.userInfo.park_id);
    // } else {
    //   this.screen.park_ids = [];
    // }
    this.fetchData();
    this.getPark();
  },
  methods: {
    //删除方法获取到的file是被删除的file
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.thumb = "";
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // handleAvatarSuccess(res, file,fileList) {
    //   if (res.code === 200) {
    //     // this.delImg(this.ruleForm.thumb);
    //     this.ruleForm.thumb = res.data.url;
    //   }
    //   // this.ruleForm.icon = URL.createObjectURL(file.raw)
    // },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        // this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.thumb = res.data.url[0];
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      if (path) {
        delImage({ file: path }).then((ress) => {});
      }
    },
    reset() {
      this.screen = {
        park_ids: [],
        title: "",
        page: 1,
        page_size: 15,
        type:''
      };
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                id:that.ruleForm.id,
                title:that.ruleForm.title,
               park_ids:this.$store.state.mainParkId,
                thumb:that.ruleForm.thumb,
                content:that.ruleForm.content,
                status:that.ruleForm.status,
                sort:that.ruleForm.sort,
                type:that.ruleForm.type
          }
              editArticle(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.fileList = []
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      articleDetail({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        this.ruleForm = {
          id: res.data.info.id,
          title: res.data.info.title,
          thumb: res.data.info.thumb,
          park_ids:this.$store.state.mainParkId,
          status: res.data.info.status,
          sort: res.data.info.sort,
          content: res.data.info.content,
          type:res.data.info.type
        };
        if (res.data.info.thumb) {
          this.fileList.push({ url: this.imageOss + res.data.info.thumb });
        }
      });
      this.drawer = true;
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delArticle({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                title:that.ruleForm.title,
                park_ids:this.$store.state.mainParkId,
                thumb:that.ruleForm.thumb,
                content:that.ruleForm.content,
                status:that.ruleForm.status,
                sort:that.ruleForm.sort,
                type:that.ruleForm.type
                
          }
              addArticle(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_ids: [],
        title: "",
        thumb: "",
        status: 1,
        content: "",
        sort: 0,
        type:1
      };
      this.fileList = []
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_ids.push(this.userInfo.park_id);
      // }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delArticle() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          delArticle({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      const data = {
        park_ids: this.screen.park_ids.toString(),
        page: this.screen.page,
        page_size: this.screen.page_size,
        title: this.screen.title,
        type:this.screen.type
      };
      articleLists(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
// select的tags过长显示...
.el-select__tags-text {
  display: inline-block;
  max-width: 140px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
</style>
